<div *ngIf="!errCode" class="upgrade-message">Creating upgrade link.. <sync-icon name="upload-inprogress"></sync-icon></div>

<app-error *ngIf="errCode" [errcode]="errCode" />